module.exports = __webpack_public_path__ + "img/Home-graphic.db412a6b.svg";